import { createFileRoute, redirect } from '@tanstack/react-router';

import { AppShell } from '@/components/layout/AppShell';

export const Route = createFileRoute('/_authenticated')({
  component: AppShell,
  beforeLoad: () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      throw redirect({ to: '/login' });
    }
  },
});
